import React from 'react';
import PropTypes from 'prop-types';
import style from './Modal.module.less';
import Icon from '../Icon';
import clsx from 'clsx';

export default function Modal({
  open,
  onClose,
  className,
  children,
  size = 'medium',
}) {
  return (
    <div className={clsx(style.modal, { [style.open]: open }, className)}>
      <div
        className={style.background}
        onClick={onClose}
        onKeyDown={onClose}
        role="button"
        aria-label="Close Modal"
        tabIndex="0"
      />
      <div className={style.foreground}>
        <Icon
          name="cancel-light"
          className={style.closeIcon}
          onClick={onClose}
          onKeyDown={onClose}
          title="Close"
          role="button"
          tabIndex="0"
        />
        <div className={clsx(style.content, style[size])}>{children}</div>
      </div>
    </div>
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  /** Callback that is fired when the close icon is clicked or the user clicks outside the modal */
  onClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(['auto', 'small', 'medium', 'large']),
};
